import { useCallback, useState } from 'react';

import { TableFilters } from '../../../../../utils/table-filters/filter-table-types';

export interface UseBulkUpdateInvoicesBills {
  selectedInvoicesBills: string[];
  isCustomSelect: boolean;
  showInvoicesBillsCheckboxes: boolean;
  filters?: TableFilters;
  triggerInvoicesBillsRefetch: number;
  handleChangeSelectedInvoicesBills: (selectedData: string[]) => void;
  handleChangeIsCustomSelect: (value: boolean) => void;
  handleChangeShowCheckboxes: (value: boolean) => void;
  handleFiltersChange: (filters: TableFilters) => void;
  handleTriggerInvoicesBillsRefetch: () => void
}

export const useBulkUpdateInvoicesBills = () => {
  const [selectedInvoicesBills, setSelectedInvoicesBills] = useState<string[]>([]);
  const [isCustomSelect, setIsCustomSelect] = useState(true);
  const [showInvoicesBillsCheckboxes, setShowInvoicesBillsCheckboxes] = useState(false);
  const [filters, setFilters] = useState<TableFilters | undefined>();
  const [triggerInvoicesBillsRefetch, setTriggerInvoicesBillsRefetching] = useState(0);

  const handleChangeSelectedInvoicesBills = useCallback((selectedData: string[]) => {
    setSelectedInvoicesBills([...selectedData]);
  }, []);

  const handleChangeIsCustomSelect = useCallback((value: boolean) => {
    setIsCustomSelect(value);
  }, []);

  const handleChangeShowCheckboxes = useCallback((value: boolean) => {
    setShowInvoicesBillsCheckboxes(value);
  }, []);

  const handleFiltersChange = useCallback((newFilters: TableFilters) => {
    setFilters(newFilters);
  }, []);

  const handleTriggerInvoicesBillsRefetch = useCallback(() => {
    setTriggerInvoicesBillsRefetching(triggerInvoicesBillsRefetch + 1);
  }, [triggerInvoicesBillsRefetch]);

  return {
    selectedInvoicesBills,
    isCustomSelect,
    showInvoicesBillsCheckboxes,
    handleChangeSelectedInvoicesBills,
    handleChangeIsCustomSelect,
    handleChangeShowCheckboxes,
    filters,
    handleFiltersChange,
    triggerInvoicesBillsRefetch,
    handleTriggerInvoicesBillsRefetch
  };
};
